import React from "react";

// Tras un despliegue, una pestaña abierta con el HTML antiguo pide
// chunks (React.lazy) que ya no existen: la navegación se quedaba en
// blanco. Aquí lo detectamos y recargamos una sola vez para coger la
// versión nueva; cualquier otro error muestra un aviso, nunca una
// página en blanco.
const RELOAD_KEY = "chunkReloadAt";
const RELOAD_WINDOW_MS = 15000;

export const isChunkLoadError = (error) => {
  if (!error) return false;
  const name = error.name || "";
  const msg = String(error.message || error);
  return (
    name === "ChunkLoadError" ||
    /Loading chunk|Loading CSS chunk|dynamically imported module|Importing a module script failed/i.test(
      msg
    )
  );
};

// Recarga una vez; si ya lo intentamos hace poco, no insistimos (evita
// bucles si el fallo no es por despliegue sino por red caída).
export const reloadOnceForChunk = () => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last < RELOAD_WINDOW_MS) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch (e) {
    // sin sessionStorage: recargamos igualmente
  }
  window.location.reload();
  return true;
};

export default class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    if (isChunkLoadError(error)) {
      if (reloadOnceForChunk()) return;
    }
    console.error("Error no controlado en la app:", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;

    const isSpanish =
      (document?.documentElement?.lang || "es").startsWith("es");

    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "14px",
          padding: "24px",
          textAlign: "center",
          fontFamily: "inter, sans-serif",
          color: "#3b352b",
        }}
      >
        <p style={{ margin: 0, fontSize: "1rem" }}>
          {isSpanish
            ? "No pudimos cargar esta página."
            : "We couldn't load this page."}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            background: "#0fa4ff",
            color: "#fff",
            border: "none",
            borderRadius: "999px",
            padding: "10px 22px",
            fontSize: "0.95rem",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          {isSpanish ? "Recargar" : "Reload"}
        </button>
      </div>
    );
  }
}
